<script setup lang="ts">
import { useCarouselContext } from '@shared/fondof-ui/components/molecules/carousel/useCarouselContext'
import type { HTMLAttributeClass } from '@shared/fondof-ui/types'

const props = defineProps<HTMLAttributeClass>()

const {
  emblaApi,
  scrollToProgress,
  scrollProgress,
  scrollbar,
  scrollbarVisible,
  mobileScrollbar,
} = useCarouselContext()

const onScrollBarChange = (event: Event) => {
  if (!emblaApi) return

  const newProgress = parseFloat((event.target as HTMLInputElement).value)

  scrollToProgress(newProgress)
}
</script>

<template>
  <div
    v-if="(scrollbar || mobileScrollbar) && scrollbarVisible"
    :class="[
      props.class,
      {
        'block sm:hidden': mobileScrollbar,
      },
    ]"
  >
    <input
      id="slider"
      class="carousel__scrollbar"
      type="range"
      min="0"
      max="1"
      step="0.001"
      :value="scrollProgress"
      @input="onScrollBarChange"
    />
  </div>
</template>

<style scoped>
.carousel__scrollbar {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: var(--scrollbar-height, 4px);
  background: var(--scrollbar-bg, #e5e7eb);
  outline: none;
  cursor: pointer;
}

.carousel__scrollbar::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: var(--thumb-width, 60px);
  height: var(--scrollbar-height, 4px);
  background: var(--thumb-bg, #000000);
  cursor: pointer;
  transition: var(--thumb-transition, background 0.2s ease);
}

.carousel__scrollbar::-moz-range-thumb {
  width: var(--thumb-width, 60px);
  height: var(--scrollbar-height, 4px);
  background: var(--thumb-bg, #000000);
  border: none;
  cursor: pointer;
  transition: var(--thumb-transition, background 0.2s ease);
}

.carousel__scrollbar::-moz-range-track {
  background: var(--scrollbar-bg, #e5e7eb);
  height: var(--scrollbar-height, 4px);
}
</style>
